    <template>
      <div>
        <table class="main-table w-100 text-right">
          <tr class="text-break">
            <td class="pl-4 text-left text-middle-bond" style="width: 35%">
              BLOCK HEIGHT
            </td>
            <td class="text-left text-middle-bond" style="width: 35%">
              DETAILS
            </td>
            <td class="text-left text-middle-bond" style="width: 18%">
              REWARD
            </td>

          </tr>
          <tr v-for="(item,index) in data" :key="index" class="hover-bg tableBlock">
            <td class="mb-none text-left d-flex flex-row align-items-center">
              <div class="ml-4 trans-icon">
                <div class="block-icon-img"></div>
              </div>
              <div class="block-rights ml-3">
                <router-link :to="`/block/${item.number}`">
                  <span>{{item.number}}</span>
                </router-link>
                <span>{{updateTimestamp(item.timestamp)}}</span>
              </div>
            </td>
            <td class="text-left">
              <div class="block-rights">
                <span>{{item.txsCount}} transactions</span>
                <span>Validator:
                  <router-link :to="`/address/${item.miner}`">
                      <span class="block-address">{{updateAddress(item.miner)}}</span>
                  </router-link>
                </span>

              </div>
            </td>
            <td class="text-left">
              <div class="text-middle-bond fontsize-13">
                0 MAPO
              </div>
            </td>
          </tr>
        </table>

<!--        <paginationSp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>-->
      </div>
    </template>

    <script>
    import { updateAge,getSortAddress } from '@/util/index'
    // import paginationSp from '@/views/_comp/pagination_sp.vue'

    export default {
      name: 'tableBlock',
      components: {
        // paginationSp,
        // btnSortArr,
      },
      props: [
        'data',
        'cfg',
      ],
      data() {
        return {
          showImg:0,
          cfg_pagination: {
            'page_size': 10, //每页条目数量
            'page_current': 1, // 当前页
            'count_items': 0, //总个数，和总页数选填其一
            'btn_num': 5, // 按钮个数
            'turnpage_top': true, // 翻页时操作滚动置顶
            'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
          },
          data_onshow: [
            {}
          ],
          data_now:[],
          contract:'',
          bykey:'',
          pairlist:''
        }
      },
      computed: {},
      watch: {},
      methods: {
        //时间
        updateTimestamp(val) {
          return updateAge(val)
        },
        //缩短地址
        updateAddress(val) {
          return getSortAddress(val)
        },
        //跳转地址
        goAddress(item) {
          var address= item.address
          this.$router.push(
              {
                path:"/address",
                query:{address:address}
              }
            )
        },


        initData(){
          let v = this
          if(!v.data)return

          v.cfg_pagination.page_current = 1

          // 计算页码
          v.cfg_pagination.count_pages = Math.ceil(v.data.length/v.cfg_pagination.page_size)

          // 过滤数据
          v.getList()
        },

        getList(){
          let v = this
          // 过滤条目
          let start = (v.cfg_pagination.page_current -1) * v.cfg_pagination.page_size
          let end = v.cfg_pagination.page_current * v.cfg_pagination.page_size
          v.data_onshow = v.data.slice(start, end)

          //判断liquidity排序
          for (const item of v.data_onshow) {
            // console.log(item,4444);
            // console.log(item.token0symbol,33333)
            if (item.token0symbol=='TRUE'){
              item.bykey=item.token0count
            }else {
              item.bykey=item.token1count
            }
          }
        },
      },
      created() {
        this.initData()
        // this.actionRequest();
      },
      mounted() {},
      //beforeDestroy() {},
      //update() {},
      //activited() {},
      //beforeRouteUpdate() {},
      //filters: {},
    };
    </script>

    <style lang="scss" scoped>
    .block-icon-img {
      width: 26px;
      height: 29px;
      background: url("../../images/table/block-black.png")no-repeat;
      background-size: 100% auto;
    }

    .tableBlock:hover {
      .trans-icon{
        background: #3772ff;
      }
      .block-icon-img {
        background: url("../../images/table/block-white.png")no-repeat;
        background-size: 100% auto;
      }
    }

    .block-address {
      cursor: pointer;
      font-size: 12px !important;
    }


    </style>
